/**
 * @React
 */
import { useEffect, useMemo } from "react";
/**
 * @React-hook-form
 */
import { UseFormSetValue } from "react-hook-form";
/**
 * @Utilities
 */
import { isMoreThanOneYear, generateNewDeadline } from "../../utilities/dates";
/**
 * @Types
 */
import { ApproveData } from "../../types";

interface WatchedValues {
  nontargeted_used_amount?: number;
  unfulfilled_used_amount_reason?: string;
  unfulfilled_used_amount_month_day?: number;
  unfulfilled_used_amount_recommendation_reason?: string;
  is_fullfilled_used_amount?: boolean;
  contract_signed_date?: Date | null;
  is_deadline_approve?: boolean;
  monitoring_new_deadline?: Date | null;
}

export const useMonitoringCgsApencyAproveHook = (watchedValues: WatchedValues, setValue: UseFormSetValue<WatchedValues>, data: ApproveData) => {
  const newDeadline = useMemo(
    () => generateNewDeadline(watchedValues.unfulfilled_used_amount_month_day || 0, data.monitoring_new_deadline ?? null),
    [watchedValues.unfulfilled_used_amount_month_day, data.monitoring_new_deadline]
  );

  const isDeadlineAprove = useMemo(
    () =>
      isMoreThanOneYear(
        watchedValues?.contract_signed_date ? new Date(watchedValues.contract_signed_date).getTime() : 0,
        watchedValues.unfulfilled_used_amount_month_day || 0
      ),
    [watchedValues.contract_signed_date, watchedValues.unfulfilled_used_amount_month_day]
  );

  useEffect(() => {
    if (isDeadlineAprove) {
      setValue("is_deadline_approve", false);
    } else {
      setValue("is_deadline_approve", true);
    }
    if (watchedValues.unfulfilled_used_amount_month_day) {
      setValue("monitoring_new_deadline", newDeadline);
    }
  }, [setValue, newDeadline, isDeadlineAprove, watchedValues.unfulfilled_used_amount_month_day]);

  return { newDeadline };
};
